export { CoinFaqSection } from './CoinFaqSection';
